
import {
  UPDATE_ANONYMOUS_USER_EMAIL,
  REMOVE_ANONYMOUS_USER_EMAIL,
} from '../../GlobalStateContainer'

export const AnonymousUserEmail = function (state = '', action) {
  switch (action.type) {
    case UPDATE_ANONYMOUS_USER_EMAIL:
      return action.anonymousUserEmail;
    case REMOVE_ANONYMOUS_USER_EMAIL:
      return '';
    default: return state;
  }
}


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/AnonymousUserEmail/anonymousUserEmailReducers.js